module.exports = __webpack_public_path__ + "media/images/admin/icons/truck-85a1997d70ae01fe8911b52574dd9362.svg";